import { render } from "./RedFlushDetailModal.vue?vue&type=template&id=928e5d00&scoped=true&ts=true"
import script from "./RedFlushDetailModal.vue?vue&type=script&lang=ts"
export * from "./RedFlushDetailModal.vue?vue&type=script&lang=ts"

import "./RedFlushDetailModal.vue?vue&type=style&index=0&id=928e5d00&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-928e5d00"]])

export default __exports__